import { render, staticRenderFns } from "./LabelFormComponent.vue?vue&type=template&id=63ca8d24&scoped=true"
import script from "./LabelFormComponent.vue?vue&type=script&lang=js"
export * from "./LabelFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca8d24",
  null
  
)

export default component.exports